export const getDocumentTitle = (contentData, locale = 'en-UK') => {
    if (!contentData || !contentData[locale]) return null;

    return (
        contentData[locale].flatMap((section) => section.blocks).find((block) => block.type === 'documentTitle')
            ?.value || null
    );
};
